
<div *ngIf="dadosVisitas.length == 0;else dadosClientes" class="d-flex justify-content-center mt-5 w-100">
  <img  src="assets/img/loading.gif" alt="loading">
  <span class="ms-2 loading-clientes " >{{ msgLoading }}</span>
</div>

<ng-template #dadosClientes>
  <div class="d-flex-custom " style="margin-top: 12px;" *ngIf="roteiro.horarioInicioRoteiro">
    <span class="tempo">{{ horarioInicioRoteiro }}</span>
    <span class="icon-play">▸</span>
    <span  class="custom-border" [ngStyle]="index % 2 === 0 ? { 'margin-top': '-4px' } : { 'margin-top': '-5px' }"></span> 
  </div>
  
  <div *ngFor="let cliente of clientes;let i = index" class="d-flex-custom custom-hover"  (mouseenter)="exibirPopup(cliente, $event)" (mouseleave)="esconderPopup(cliente)" [ngClass]="{'ultimo-cliente' : ultimoRoteiro}">
  
      <div *ngIf="cliente.mostrarPopup" class="popup">   
  
      <div style="background-color: #fff;"> 
        <p class="ms-2 mb-0" style="color: #101316; font-size: 20px; font-weight: 600; padding: 8px;">Cliente  </p> 
      </div>
      <div style="border-bottom: 1px solid #C0C1C3"></div>
      <div id="esriPopUpWrapper">
        <div class="d-flex justify-content-between">
          <div>
            <span class="nome-fantasia-pop me-1">{{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? cliente.NomeFantais : cliente.RazaoSocial }}</span>
            <span>{{cliente.CodigoCliente }}</span>
          </div>
          <button class="btn-clean" (click)="abreStreetViewPrincipal(cliente.Latitude, cliente.Longitude)">
            <img src="assets/img/icons/icon_eye_green.svg" alt="">
          </button>
        </div>
        <div class="dados">
            <div class="info-cliente">
              <p class="pp-nome-fantasia-cliente">{{ cliente.NomeFantasia}}</p>
              <p class="pp-nome-fantasia-cliente">CNPJ: {{ cliente.CnpjCpf | cpfCnpj }}</p>
              <p class="pp-doc-cliente"><span></span></p>
              <div class="endereco-cliente">
                  <p class="endereco-cliente-popup">{{ cliente.Endereco }}</p>
                  <p class="endereco-cliente-popup"> {{ cliente.Bairro }} - {{ cliente.Cidade }}/{{ cliente.UF }}</p>
                  <p class="endereco-cliente-popup">CEP: {{ cliente.Cep }}</p>
              </div>
              <table class="table table-sm">
                <thead>
                  <tr >
                    <th class="titulo-table-pedidos">Pedido</th>
                    <th class="titulo-table-pedidos">NF</th>
                    <th class="titulo-table-pedidos">Peso </th>
                    <th class="titulo-table-pedidos">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pedido of cliente.pedidos">
                    <td>{{ pedido.NumeroPedido }}</td>
                    <td>{{ pedido.Nf }}</td>
                    <td>{{ pedido.Peso }} Kg</td>
                    <td>{{ pedido.ValorPedido | currency: 'BRL' }} </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
      
        <div class="footer">         
          <div class="card-ajudante" *ngIf="expression"> Entrega realizada pelo ajudante </div>   
          
          <div *ngIf="carregandoClientes;else iconClientes" class="d-flex justify-content-center mt-2 w-100">
            <img  src="assets/img/loading.gif" alt="loading">
            <span class="ms-2 loading-clientes " >{{ msgLoading }}</span>
          </div>

          <ng-template #iconClientes>
            <div class="lista-acoes-popup" *ngIf="listaAcoesPorCliente.length">
              <div class="item-lista-acoes"  *ngFor="let acao of listaAcoesPorCliente" > <img class="lista-acoes-popup-items-img" [src]="acao.image"  > 
                <span *ngIf="acao.data">{{ acao.data }}</span> 
                <span *ngIf="acao.hora"> {{ acao.hora }} </span> </div>;           
            </div>
          </ng-template>
          
          <ng-container *ngIf="ocorrencias.length">
            <div *ngIf="ocorrencias.length">
              <span class="tit-principal-oc">Ocorrência(s) no cliente ({{ ocorrencias.length }})</span>

              <div class="container-oc" *ngFor="let ocorrencia of ocorrencias">
                <div class="content-oc">
                  <div class="dados-oc" style="font-size: 14px;">
                    <span>{{ ocorrencia.Motivo }} - {{ ocorrencia.CodigoOcorrencia }}</span>
                    <img class="ms-2" src="assets/img/icons/ticket.svg" alt="">
                  </div>
                  <div class="data-oc">{{ ocorrencia.Data | date:'dd/MM/yyyy HH:mm' }}</div>
                </div>
                <div class="content-btn-oc">
                  <span data-tooltip="Visualizar mensagem" data-tooltip-pos="top">
                    <img class="ms-2" src="assets/img/icons/chat-right-text.svg" alt="" (click)="openModalMsgOc(ocorrencia)">
                  </span>
                  <span data-tooltip="Ir para ocorrência" data-tooltip-pos="top">
                    <img class="p-2" src="assets/img/icons/box-arrow-up-right.svg" alt="" (click)="abrirOcorrencia(ocorrencia)">
                  </span>
                </div>
              </div>
          </div>
        </ng-container>
        </div>
      </div>
    </div>
    <img [src]="cliente.icon" >
    <span [ngClass]="{ 'custom-border': cliente.IdRoteiroPedidoSituacao >= 5, 'custom-border-open': cliente.IdRoteiroPedidoSituacao < 5 }"
      [ngStyle]="cliente.IdRoteiroPedidoSituacao >= 5 ? { 'border-top': '1px solid #4C5054' } : { 'border-top': '1px solid #C0C1C3' }">
    </span>
  
  </div>    
  <div class="d-flex-custom">
    <img [src]="roteiro.totalClienteEntregue === roteiro.totalCliente? 'assets/img/bandeira-visita-finalizada.svg' :'assets/img/bandeira-visita.svg' " alt='Bandeira Visita' class="custom-bandeira-visita" >
    <span [ngClass]="{ 'custom-border': roteiro.totalClienteEntregue === roteiro.totalCliente , 'custom-border-open': roteiro.totalClienteEntregue !== roteiro.totalCliente  }"  style="margin-top: 6px;"></span> 
  </div>
</ng-template>
